import { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import Affiliate from '../../../../templates/Affiliate/Affiliate';
import { Button, Modal } from 'react-bootstrap'
import useCallApi from '../../../../hooks/useCallApi';
import { SystemMessageContext } from '../../../../context/SystemMessageContext'
import Loading from '../../../../templates/UI/Loading/Loading';
import Dollars from '../../../../templates/Dollars/Dollars';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Campaign from '../../../../templates/Campaign/Campaign';
import DownloadCSV from '../../../../templates/DownloadCSV/DownloadCSV'

export default function MonitoringRatesDetail({modalData, setModalData}) {
    
    const { showSystemMessage } = useContext(SystemMessageContext)

    const { dataLoaded, data, refetch, setData } = useCallApi(`campaignHealthMonitoring/rates/details?campaignId=${modalData.campaignId}&ratename=${modalData.ratename}&commission=${modalData.commission}&startDate=${modalData.startDate}&endDate=${modalData.endDate}`, 'GET', {}, [])

    useEffect(() => {
        if(modalData.open) {
            refetch()
        }
    }, [modalData.campaignId, modalData.ratename, modalData.startDate, modalData.endDate, modalData.commission]);

    return (
        <Modal show={modalData.open} onHide={() => setModalData({...modalData, open:false})} size="xl" scrollable={true}>
            <Modal.Header closeButton>
                <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                        <span className="mr-2">Rate Discrepancies:</span>
                        {(dataLoaded && data.campaign) && <Campaign oid={data.campaign.id} name={data.campaign.name} status={data.campaign.status.name} />}
                    </div>
                    <div className="ml-2">
                        {dataLoaded && data.success &&
                            <DownloadCSV
                                filename={`Rate Discrepancy Details - ${data.campaign.name} (${modalData.campaignId}) for ${modalData.startDate}-${modalData.endDate}`}
                                headerLabels={['Lead ID', 'Click ID', 'Affiliate Id', 'Affiliate Name', 'Expected Aff', 'Expected Net', 'Aff Payout', 'Commission', 'Lead Date']}
                                data={data.report}
                                dataLabels={['lead_id', 'click_action_id', 'affiliate_id', 'name', 'expected_aff_rate', 'expected_net_rate', 'affiliate_payout', 'commission_amount',  'lead_date']} />}
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body className="p-0 m-0">
                <table className="table table-striped table-card m-0 table-hover text-small">
                    <thead>
                        <tr className="text-secondary">
                            <th>Lead ID</th>
                            <th>Click ID</th>
                            <th>Affiliate</th>
                            <th className="text-right border-left">Expected Aff</th>
                            <th className="text-right">Expected Net</th>
                            <th className="text-right border-left">Aff Payout</th>
                            <th className="text-right">Commission</th>
                            <th className="border-left">Lead Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataLoaded ? (
                            (!data.report || (data.report && data.report.length === 0)) ? (
                                <tr>
                                    <td colSpan={8}>No stats available </td>
                                </tr>
                            ) : (
                                data.report.map((item, index) => {                                    
                                    return (
                                        <tr>
                                            <td>{item.lead_id}</td>
                                            <td><Link to={`/searchId?actionId=${item.click_action_id}`}>{item.click_action_id}</Link></td>
                                            <td><Affiliate name={item.name} aid={item.affiliate_id} priority={item.aff_priority} status={item.status} /></td>
                                            <td className="text-right border-left"><Dollars value={item.expected_aff_rate} /></td>                                            
                                            <td className="text-right"><Dollars value={item.expected_net_rate} /></td>
                                            <td className="text-right border-left"><Dollars value={item.affiliate_payout} /></td>
                                            <td className="text-right"><Dollars value={item.commission_amount} /></td>
                                            <td className="border-left">{moment.utc(item.lead_date).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                    )
                                })
                            )
                        ) : (
                            <tr>
                                <td colSpan={8}>
                                    <Loading />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </Modal.Body>            
        </Modal>
    )
}